<div class="report row mx-md-0 px-md-0">
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 d-flex justify-content-start">
        <span class="">Date:</span>
      </div>
      <div class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.dateSaved }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 d-flex justify-content-start">
        <span class="">Time:</span>
      </div>
      <div class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.timeSaved }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 d-flex justify-content-start">
        <span class="">Client ID:</span>
      </div>
      <div class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerId }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Client:</span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 d-flex justify-content-start">
        <span class="">Phone No.:</span>
      </div>
      <div class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerPhone1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 d-flex justify-content-start">
        <span class="">Savings Balance:</span>
      </div>
      <div class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.savingsBalance | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 d-flex justify-content-start">
        <span class="">Savings Added: </span>
      </div>
      <div class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.savingsAdded | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 d-flex justify-content-start">
        <span class="">Savings Withdraw:</span>
      </div>
      <div class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.savingsRemoved | number }}
        </span>
      </div>
    </div>
  </div>
</div>
<div class="row mt-md-2 pt-2 pb-1 border-top">
  <div class="field col-12 col-md-6">
    <div class="row">
      <div class="col-5 col-lg-3 d-flex justify-content-start">
        <span class="">Station: </span>
      </div>
      <div class="col-7 col-lg-9 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.stationName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6">
    <div class="row">
      <div class="col-5 col-lg-4 col-xl-3 d-flex justify-content-start">
        <span class="">Station User:</span>
      </div>
      <div class="col-7 col-lg-8 col-xl-9 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.userName }}
        </span>
      </div>
    </div>
  </div>
</div>
